"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformId = transformId;
exports.transformIds = transformIds;
exports.nestedArrayTransform = nestedArrayTransform;
exports.nestedTransform = nestedTransform;
exports.createExcludingDTOTransformer = createExcludingDTOTransformer;
exports.createDTOTransformer = createDTOTransformer;
exports.createRelationTransformer = createRelationTransformer;
const lodash_1 = require("lodash");
function transformId(rename) {
    return [
        rename,
        (value) => {
            var _a;
            if (value === undefined) {
                return undefined;
            }
            return ((_a = value === null || value === void 0 ? void 0 : value.id) !== null && _a !== void 0 ? _a : null);
        }
    ];
}
function transformIds(rename) {
    return [
        rename,
        (value) => {
            if (value === undefined) {
                return undefined;
            }
            return value.map((b) => b.id);
        }
    ];
}
function nestedArrayTransform(mapper, rename) {
    return [
        rename,
        (value) => {
            if (value === undefined) {
                return undefined;
            }
            return value.map((v) => mapper(v));
        }
    ];
}
function nestedTransform(mapper, rename) {
    return [
        rename,
        (value) => {
            if (value === undefined) {
                return undefined;
            }
            if (value === null) {
                return null;
            }
            return mapper(value);
        }
    ];
}
function createExcludingDTOTransformer(a, b, excludes) {
    const omits = [...excludes];
    return (v) => ({
        ...(0, lodash_1.omit)(v, ...omits)
    });
}
function createDTOTransformer(a, b, excludes, mappings) {
    const omits = [
        ...excludes,
        ...Object.keys(mappings)
    ];
    const preparedMappers = Object.entries(mappings).map(([oldKey, [newKey, mapper]]) => {
        return [newKey, (o) => mapper(o[oldKey], oldKey, o)];
    });
    return (v) => ({
        ...(0, lodash_1.omit)(v, ...omits),
        ...Object.fromEntries(preparedMappers.map(([k, m]) => [k, m(v)]))
    });
}
function createRelationTransformer(a, b, exclude, transform, rename) {
    return createDTOTransformer(a, b, [exclude], {
        [transform]: [rename, (v) => v.id]
    });
}
